import {AnyAction} from "redux";

export const SET_LOT = "SET_LOT";

const initialState = {
    lot: null,
}

export const lotReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case SET_LOT: return { ...state,
            lot: action.payload
        }
        default: return state
    }
}